import React from 'react';
import { Box, Button, CircularProgress, DialogContentText, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import styles from '../../components/index.module.scss';
import deleteSvg from '../../assets/images/delete.svg';
import { useDispatch, useSelector } from 'react-redux';
import { appActions } from '../../store/appState';

interface ConfirmModalProps {
  open: boolean,
  close: Function,
  onConfirm: Function;
  content: string;
}

export default function ConfirmClose(props: ConfirmModalProps) {
  const appState = useSelector((state: any) => state.app);
  const dispatch = useDispatch();

  return (
    <div>
      <Dialog
        open={props.open}
        classes={{ paper: styles.confirmModal }}
        onClose={() => props.close()}
        style={{ padding: '3rem' }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description" className={styles.vertical}>
            <img src={deleteSvg} alt="delete" style={{ height: '10rem', width: '10rem' }} />
            <Typography className={styles.confirmModal_title}>Confirm Close</Typography>
            <Box style={{ maxWidth: '50%', marginTop: '1rem' }}>
              <Typography className={styles.confirmModal_text}>{props.content}</Typography>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions className={styles.vertical}>
          {!appState.isSubmitting && (
            <Button onClick={() => props.onConfirm()} variant="contained" className={styles.confirmModal_Confirm}>
              Close
            </Button>
          )}
          {appState.isSubmitting && (
            <Button variant="contained" className={styles.confirmModal_Confirm}>
              <CircularProgress size={30} color="inherit" className={styles.circularProgress} />
            </Button>
          )}
          <Button onClick={() => dispatch(appActions.setIsDeleting(false))} className={styles.confirmModal_Cancel}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
